module.exports = __webpack_public_path__ + "static/media/logo-white.586742e5.png";